import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subject, filter, map, takeUntil } from 'rxjs';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
} from '@angular/router';
import { SidebarComponent } from './organisms/sidebar/sidebar.component';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { JwtHelperService } from '@auth0/angular-jwt';
import { tokenGetter } from 'projects/speaker-platform/src/main';
import { ToastsComponent } from './atoms/toasts/toasts.component';
import { UserService } from '@common/services/user.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SidebarComponent,
        RouterOutlet,
        CommonModule,
        ToastsComponent,
    ]
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private jwtHelper: JwtHelperService,
    protected userService: UserService,
  ) {}

  fullPage: boolean = false;
  pageTitle: string = '';
  sidebarCollapsed: boolean = false;

  token: any;
  destroy$: Subject<boolean> = new Subject<boolean>();
  // userData: any;

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child) {
            if (child.firstChild) {
              child = child.firstChild;
            } else if (child.snapshot.data && child.snapshot.data) {
              return child.snapshot.data;
            } else {
              return null;
            }
          }
          return null;
        })
      )
      .subscribe((customData: any) => {
        this.checkTokenValidity();
        this.fullPage = customData.fullPage;
        this.pageTitle = customData.title;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  checkTokenValidity() {
    if (this.jwtHelper.isTokenExpired(tokenGetter()) || this.token === null) {
      localStorage.removeItem('jwt');
      localStorage.removeItem('mercureAuthorization');
      const isResetPasswordRoute = this.router.url.startsWith('/reset-password/')
      const isValidateReleveRoute = this.router.url.startsWith('/validation-releves/')
      this.router.url !== '/reinitialiser-mdp' && !isResetPasswordRoute &&!isValidateReleveRoute && this.router.navigate(['/login']);
    }
    else {
      this.getToken()
    }
  }

  getToken() {
    const token = tokenGetter();
    const isResetPasswordRoute = this.router.url.startsWith('/reset-password/')
    const isValidateReleveRoute = this.router.url.startsWith('/validation-releves/')
    if (token && !this.userService.user) {
      this.token = this.jwtHelper.decodeToken(token);
      if (
        this.token.roles.includes('ROLE_COMEDIENNE_ADMIN') ||
        this.token.roles.includes('ROLE_ADMIN') ||
        this.token.roles.includes('ROLE_COMEDIENNE_INTERNE') ||
        this.token.roles.includes('ROLE_USER_INTERNE')
      ) {
        this.userService
          .getUtilisat(this.token.utilisat)
          .pipe(takeUntil(this.destroy$))
          .subscribe();

      } else {
        this.userService
          .getSpeaker(this.token.login)
          .pipe(takeUntil(this.destroy$))
          .subscribe();
      }
    }
    if (!token && this.router.url !== '/reinitialiser-mdp' && !isResetPasswordRoute && isValidateReleveRoute) {
      this.router.navigate(['/login']);
    }

    if (token && this.token.roles.includes('ROLE_USER_INTERNE') && !this.token.roles.includes('ROLE_COMEDIENNE_ADMIN') && !this.token.roles.includes('ROLE_COMEDIENNE_COMPTA')  && !this.router.url.startsWith('/admin/planning') && this.router.url !== '/login') {
      this.router.navigate(['/admin/planning']);
    }
  }

  title = 'speaker-platform';
}
